<template>
  <div class="home d-flex justify-center align-center">
    <v-container fluid>
      <!-- <login-register /> -->
      <search />
    </v-container>
  </div>
</template>

<script>
import LoginRegister from '@/components/Frontend/LoginRegister.vue';
import Search from '@/components/Frontend/Search.vue';
export default {
  name: 'Home',
  components: {
    LoginRegister,
    Search,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.home {
  min-height: 100vh;
  background-color: #f4f8ff;
  background: linear-gradient(160deg, #eaf1fc 0%, #f9fbff 55%, #ffffff 100%);
  background-size: cover;
  overflow: hidden;
}
</style>
